/* src/app/pages/register-fuel/register-fuel.component.scss */
main {
  width: 100%;
  max-width: 600px;
  margin: auto;
  padding-bottom: 64px;
}
form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
form ion-item {
  border-radius: 10px;
  --background: #fff;
}
form ion-card {
  margin: 0;
  --background: #fff;
}
.fuel-description {
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 12px;
}
.fuel-place-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}
.fuel-place-container .about-fuel-place ion-label {
  margin-top: 6px;
  color: #626262;
}
.input-invalid {
  color: var(--ion-color-danger);
}
.input-valid {
  color: var(--ion-color-success);
}
/*# sourceMappingURL=register-fuel.component.css.map */
